export enum TabCategoryEnum {
	MY_CATEGORIES = 0,
	ASSIGNED_CATEGORIES = 1,
  }
